import { BuildDto } from '../../apiGateway/Dtos/BuildDto';
import { MapDtoToArtefactModel } from '../Artefact/ArtefactMap';
import { Artefact } from '../Artefact/Artefact';

export const MapDtoToBuildModel = (dto: BuildDto) => {
  return {
    id: dto.id,
    commitSha: dto.commitSha,
    createdAt: dto.createdAt,
    isPublic: dto.isPublic,
    isSharedWithUser: dto.isSharedWithUser,
    releaseNotes: dto.releaseNotes,
    triggeredBy: dto.triggeredBy,
    triggeredByUsername: dto.triggeredByUsername,
    type: dto.type,
    artefacts: dto.artefacts.map(artefact => Artefact.create(MapDtoToArtefactModel(artefact)))
  };
};
